import useCustomSelector from './useCustomSelector';

const useSession = () => {
  const { authenticated, checked } = useCustomSelector(state => state.session);

  return { authenticated, checked };
};

export default useSession;